import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import data from "../data/personal.json";
import admin from "../data/admin.json";
import common from "../data/common.json";
import portal from "../data/portal.json";
import NotFoundPage from "../views/common/NotFoundPage";
// 路由模块
import PrivateRoute from "../routes/PrivateRoute";
// 布局模块
import PortalLayout from "../layouts/PortalLayout";
import PersonalLayout from "../layouts/PersonalLayout";

// common布局
export default function AppRoute() {
  return (
    <Routes>
      {/* 门户页面 */}
      <Route index element={<Navigate to="/home" replace />} />
      <Route element={<PortalLayout />}>
        {portal.map((route) => {
          const LazyComponent = React.lazy(() =>
            import(`../views/portal/${route.component}`)
          );
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyComponent />
                </Suspense>
              }
            />
          );
        })}
      </Route>

      {/* 公共页面 暂无公共配置 */}
      <Route element="">
        {common.map((route) => {
          const LazyComponent = React.lazy(() =>
            import(`../views/common/${route.component}`)
          );
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyComponent />
                </Suspense>
              }
            />
          );
        })}
      </Route>

      {/* 个人中心 ==> 权限受保护页面 */}
      <Route
        element={
          <PrivateRoute
          //   roleRequired="admin" 可以适配admin 和 user 用户
          >
            <PersonalLayout />
          </PrivateRoute>
        }
      >
        {data.map((route) => {
          const LazyComponent = React.lazy(() =>
            import(`../views/personal/${route.component}`)
          );
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyComponent />
                </Suspense>
              }
            />
          );
        })}
      </Route>

      {/* 管理员 */}
      <Route
        element={
          <PrivateRoute
          roleRequired="admin"
          >
            <PersonalLayout />
          </PrivateRoute>
        }
      >
        {admin.map((route) => {
          const LazyComponent = React.lazy(() =>
            import(`../views/personal/admin/${route.component}`)
          );
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyComponent />
                </Suspense>
              }
            />
          );
        })}
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
